import Loader from "components/Loader";
import React from "react";
import { useSearchParams } from "react-router-dom";
import { useGetSpecificTransactionQuery } from "state/api";
import TransactionStageSelector from "./TransactionStageSelector";
import Header from "components/Header";
import { Box } from "@mui/material";

const ProcessTransaction = () => {
  const [searchParams] = useSearchParams();
  const transactionId = searchParams.get("id");
  const { data, loading, error } =
    useGetSpecificTransactionQuery(transactionId);

  if (loading) return <Loader />;

  if (error || !data) return <div>Error</div>;

  if (data && data.transactionStatus)
    return (
      <>
        <Box m="1.5rem 2.5rem">
          <Header title="Process Transaction" />
          <TransactionStageSelector data={data} />
        </Box>
      </>
    );

  return <div>Error</div>;
};

export default ProcessTransaction;
